// extracted by mini-css-extract-plugin
export default {"wrapper":"X6OkiJS"};